var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pb-5" }, [
    _c("div", { staticClass: "header-wrapper pt-5" }, [
      _c("div", { staticClass: "container homebase-container" }, [
        _c("div", { staticClass: "pb-4" }, [
          _c("div", [_c("back-to-home-button")], 1)
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("nav", { staticClass: "navbar navbar-expand-lg pt-3 px-0 pb-0" }, [
          _c(
            "div",
            {
              staticClass: "collapse navbar-collapse",
              attrs: { id: "bookmarks-navbar" }
            },
            [
              _c(
                "ul",
                { staticClass: "navbar-nav" },
                _vm._l(_vm.navTabs, function(navTab, i) {
                  return _c(
                    "li",
                    {
                      key: i,
                      staticClass: "nav-item px-4 py-2 d-block",
                      on: {
                        click: function($event) {
                          return _vm.updateNavTab(i)
                        }
                      }
                    },
                    [
                      _c("a", { class: { active: _vm.isTabActive(i) } }, [
                        _vm._v(_vm._s(navTab.title))
                      ])
                    ]
                  )
                }),
                0
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container homebase-container nav-wrapper" }, [
      _vm.navTabs[_vm.currentTabIndex].component
        ? _c(
            "div",
            [
              _c(_vm.navTabs[_vm.currentTabIndex].component, {
                tag: "component"
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Bookmarks")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-description row" }, [
      _c("div", { staticClass: "col-lg-10 col-12" }, [
        _c("div", { staticClass: "pb-2" }, [
          _vm._v(
            "\n            View all the pages you bookmarked on Autodesk One and followed on\n            SharePoint here in one place.\n          "
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("Pinned links")]),
            _vm._v(
              " will be prioritized to appear on\n              your Autodesk One home page for easy access. You can pin up to 6\n              bookmarks by clicking the thumbtack icon below.\n            "
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("\n              Click "),
            _c("strong", [_vm._v("Recommended bookmarks")]),
            _vm._v(
              " to view links suggested\n              based on your role, location, or other job attributes specific\n              to you.\n            "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "d-block d-lg-none",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#bookmarks-navbar",
          "aria-controls": "bookmarks-navbar",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/image/hamburger_menu_icon.svg"),
            alt: "hamburger-dropdown"
          }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1f8e38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1f8e38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/pages/AutodeskOneBookmarksPage.vue
// module id = null
// module chunks = 